import { createClient } from "@supabase/supabase-js";
import { browserSettings } from "~/settings";

export const supabase = createClient(
  browserSettings.SUPABASE_URL,
  browserSettings.SUPABASE_KEY_ANON,
);
